export const routePaths = {
  NNG: "/",
};

export const nngTabs = {
  ASSOCIAZIONE: "Associazione/Riepilogo",
  STORICO_CONFIGURAZIONI: "Storico configurazioni",
};

export const gestioneTabs = {
  GESTIONE_NUMERI_NERI: "Numeri Neri/Gruppi di Numeri Neri",
  AREE_DI_ORIGINE_CHIAMATE: "Aree di Origine Chiamate",
  FASCE_ORARIE: "Fasce Orarie",
  MESSAGI_VOCALI: "Messaggi Vocali",
};

export const NumeriSpeciali_Piani_Di_Instradamento = {
  CHIAMATE: "Disabilitazione Chiamate (Barring)",
  LISTE_BIANCHE: "Liste Bianche",
  MESSAGGI: "Messaggi Vocali su base Origine",
  REGOLE: "Regole di Applicazione",
  INSTRADAMENTI: "Altri Instradamenti",
};

export const SELECTED_CUSTOMER = "SELECTED_CUSTOMER";

export const ENDPOINT_CREATE = "CREATE";
export const ENDPOINT_ORDINARY = "ORDINARY";
export const ENDPOINT_MENU = "MENU";
export const ANNUNCIO_LIBERO = "Annuncio libero";
export const ANNUNCIO_GRATUITO_LIBERO = "Annuncio gratuito libero";
